import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	outwardDescription: {
		id: 'portfolio-3-dependency-settings.ui.dependency-list.dependency-list-item.outward-description',
		defaultMessage: 'If A {outwardDescription} B then A is scheduled before B',
		description: 'Description for the outward relationship',
	},
	inwardDescription: {
		id: 'portfolio-3-dependency-settings.ui.dependency-list.dependency-list-item.inward-description',
		defaultMessage: 'If A {outwardDescription} B then B is scheduled before A',
		description: 'Description for the inward relationship',
	},
	swap: {
		id: 'portfolio-3-dependency-settings.ui.dependency-list.dependency-list-item.swap',
		defaultMessage: 'swap',
		description: 'Text for the button to swap the dependency direction',
	},

	swapLabel: {
		id: 'portfolio-3-dependency-settings.ui.dependency-list.dependency-list-item.swap-label',
		defaultMessage: 'Swap {name} direction',
		description: 'Label for the dependency direction swap button',
	},
	issueLinkTypeLabel: {
		id: 'portfolio-3-dependency-settings.ui.dependency-list.dependency-list-item.issueLinkTypeLabel',
		defaultMessage: 'Issue link type selected for {type}',
		description: 'Label for the issue link type, where type is the issueLinkType selected',
	},
});
